import styled, { css } from 'styled-components';
import { customColors } from '../components/colors/color';


export enum ColorMode {
  YELLOW = 'YELLOW',
  GREEN = 'GREEN',
  LIGHT_GREEN = 'LIGHT_GREEN',
  ORANGE = 'ORANGE',
  PURPLE = 'PURPLE',
  GRAY = 'GRAY',
  RED = 'RED',
  BLUE = 'BLUE',
  PINK = 'PINK'
}


export const StatusMode = styled.div<{ colorType?: string, customWidth?: string }>`
  width: max-content;
  padding: 16px;
  height: 24px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  ${({ colorType }) => {
    if (ColorMode.GREEN === colorType) {
      return css`
            background-color: ${customColors.green_150};
          `;
    }
    if (ColorMode.PINK === colorType) {
      return css`
            background-color: ${customColors.orange_150};
          `;
    }
    if (ColorMode.YELLOW === colorType) {
      return css`
            background-color: ${customColors.yellow_150};
          `;
    }
    if (ColorMode.PURPLE === colorType) {
      return css`
            background-color: ${customColors.perpule_100};
          `;
    }
    if (ColorMode.GRAY === colorType) {
      return css`
            background-color: ${customColors.gray_320};
          `;
    }
    if (ColorMode.RED === colorType) {
      return css`
            background-color: ${customColors.red_70};
          `;
    }
    if (ColorMode.LIGHT_GREEN === colorType) {
      return css`
            background-color: ${customColors.green_120};
          `;
    }
    if (ColorMode.ORANGE === colorType) {
      return css`
            background-color: ${customColors.orange_150};
          `;
    }
    if (ColorMode.BLUE === colorType) {
      return css`
            background-color: ${customColors.primary_100};
          `;
    }
  }}
  & span {
    font-size: 14px;
    ${({ colorType }) => {
    if (ColorMode.GREEN === colorType) {
      return css`
            color: ${customColors.green_500};
          `;
    }
    if (ColorMode.YELLOW === colorType) {
      return css`
            color: ${customColors.yellow_900};
          `;
    }
    if (ColorMode.PURPLE === colorType) {
      return css`
            color: ${customColors.perpule_700};
          `;
    }
    if (ColorMode.PINK === colorType) {
      return css`
            color: ${customColors.orange_850};
          `;
    }
    if (ColorMode.GRAY === colorType) {
      return css`
            color: ${customColors.gray_700};
          `;
    }
    if (ColorMode.RED === colorType) {
      return css`
            color: ${customColors.red_250};
          `;
    }
    if (ColorMode.LIGHT_GREEN === colorType) {
      return css`
            color: ${customColors.green_550};
          `;
    }
    if (ColorMode.ORANGE === colorType) {
      return css`
            color: ${customColors.orange_700};
          `;
    }
    if (ColorMode.BLUE === colorType) {
      return css`
            color: ${customColors.primary_200};
          `;
    }
  }}
  }
`;

export const StyledResultRow = styled.div`
    display: flex;
    align-items: center;
    padding-bottom: 16px;
    & span {
        padding-left: 4px;
    }
`;

export const StyledResultContainer = styled.div`
    display: flex;
    align-items: flex-start;
    flex-direction: column;
`;

export const Image = styled.div<{ src?: any }>`
  background-image: url(${p => p.src});
  background-position: 50% 50%;
  background-size: contain;
  background-repeat: no-repeat;
`;

export const StyledMotions = styled.div<{ isMulti?: boolean }>`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: ${p => p.isMulti ? 'space-around' : 'center'};
`;

export const StyledTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  & svg.text__arrow {
    transform: rotate(0deg) !important;
    width: 20px !important;
    height: 20px !important;
  }

`;
export const StyledMotionImages = styled.div<{ isMulti?: boolean }>`
  display: flex ;
  flex-direction: row;
  align-items: center;
  justify-content: ${p => p.isMulti ? 'flex-start' : 'center'};
  width: 100%;
  
`;

export const StyledCard = styled.div`
  background-color: #ffffff;
  height: 64px;
  width: 320px;
  border-radius: 4px;
  display: flex;
  justify-content: space-around;
  margin-top: 24px;
  & svg.icon__arrow {
    transform: rotate(180deg) !important;
    margin-top: 8px;
    width: 40px;
  }
`;

export const StyledDialogMovement = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  & div.description { 
    padding: 40px 16px 20px 16px;
    display: flex;
    flex-direction: column;
    font-size: 16px;
    /* font-weight: 500; */
    line-height: 1.5;
    & span {
      padding-top: 4px;
    }
  }

`;

export const StyledDialogMovementTitle = styled.div`
  display: flex;
  align-items: 'center';
  justify-content: space-between;
  padding: 24px;
  width: 100%;
  & svg {
    font-size: 24px;
    cursor: pointer;
  }
  & p {
    font-size: 16px;
    font-weight: 600;
  }
`;

export const StyledHelper = styled.div`
  padding-top: 8px;
  font-size: 16px;
  & span.title {
    color: red;
    padding: 16px 0px;
    display: inline-block;
  }
  & ul {
    padding-right: 16px;
  }
`;